'use strict';

var MultiCheckboxGroupDirective = function MultiCheckboxGroupDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/multi-checkbox-group.html'),
    scope: {
      //Expected array of objects in format [{value: 'valueSetInModel', label: 'checkboxVisibleLabel'}]
      checkboxValues: '=',
      //data model for storing the checkbox values. format: ['valueSetInModel1', 'valueSetInModel2']
      checkboxModel: '='
    }
  };
};
MultiCheckboxGroupDirective.$inject = [];
module.exports = MultiCheckboxGroupDirective;